import { useState } from "react";
import { api, apiError } from "../api";
import { Layout } from "../components/Layout";
import { useSettings } from "../hooks";
import { captureUtm } from "../utm";
import { useReveal } from "../useReveal";

export default function Iletisim() {
  const s = useSettings();
  useReveal(!!s);
  const [form, setForm] = useState({ ad: "", telefon: "", email: "", mesaj: "", kvkk: false, website: "" });
  const [durum, setDurum] = useState("");
  const [hata, setHata] = useState("");
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const gonder = async (e) => {
    e.preventDefault();
    setHata("");
    if (!/^[+]?[0-9\s]{10,}$/.test(form.telefon)) return setHata("Geçerli bir telefon numarası girin (ülke koduyla).");
    if (!form.kvkk) return setHata("Devam etmek için KVKK onayı gereklidir.");
    setGonderiliyor(true);
    try {
      await api.post("/leads", { ...form, kaynak: "İletişim formu", proje: "", utm: captureUtm() });
      setDurum("ok");
    } catch (err) {
      setHata(apiError(err));
    } finally { setGonderiliyor(false); }
  };

  return (
    <Layout mesaj="İletişim kurmak istiyorum">
      <section className="sayfa-basi">
        <div className="veri bel">İletişim</div>
        <h1 className="h-dev bel" style={{ margin: "14px 0 40px" }}>Satış ofisimize gelin</h1>
        <div className="konum">
          <div className="bel">
            {durum === "ok" ? (
              <div className="tesekkur" data-testid="iletisim-tesekkur">
                <h3 className="h-orta">Teşekkürler</h3>
                <p style={{ color: "var(--metin-2)", marginTop: 10 }}>Talebiniz alındı, en kısa sürede sizi arayacağız.</p>
              </div>
            ) : (
              <form className="form" onSubmit={gonder} data-testid="iletisim-form">
                <input className="honeypot" tabIndex={-1} autoComplete="off" value={form.website} onChange={(e) => set("website", e.target.value)} aria-hidden />
                <div><label>Ad Soyad</label><input required value={form.ad} onChange={(e) => set("ad", e.target.value)} data-testid="iletisim-ad" /></div>
                <div><label>Telefon (ülke koduyla)</label><input required placeholder="+90 5xx xxx xx xx" value={form.telefon} onChange={(e) => set("telefon", e.target.value)} data-testid="iletisim-telefon" /></div>
                <div><label>E-posta</label><input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="iletisim-email" /></div>
                <div><label>Mesaj</label><textarea rows={4} value={form.mesaj} onChange={(e) => set("mesaj", e.target.value)} data-testid="iletisim-mesaj" /></div>
                <label className="kvkk"><input type="checkbox" checked={form.kvkk} onChange={(e) => set("kvkk", e.target.checked)} data-testid="iletisim-kvkk" /><span>{s?.kvkk_text}</span></label>
                {hata && <div className="form-hata" data-testid="iletisim-hata">{hata}</div>}
                <button className="dugme" disabled={gonderiliyor} data-testid="iletisim-gonder">{gonderiliyor ? "Gönderiliyor…" : "Gönder"}</button>
              </form>
            )}
          </div>
          <div className="bel">
            <div className="mesafe"><span>Adres</span><b>{s?.address}</b></div>
            <div className="mesafe"><span>Telefon</span><b>{s?.phone}</b></div>
            <div className="mesafe"><span>E-posta</span><b>{s?.email}</b></div>
            <div className="mesafe"><span>Çalışma saatleri</span><b>{s?.working_hours}</b></div>
            {s?.map_embed && (
              <figure style={{ marginTop: 24, aspectRatio: "16/10", background: "var(--tas)" }}>
                <iframe title="Harita" src={s.map_embed} width="100%" height="100%" style={{ border: 0 }} loading="lazy" />
              </figure>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
}
